export function draggableSlider() {
  gsap.registerPlugin(Draggable, InertiaPlugin);

  const wrappers = document.querySelectorAll('.slider__wrapper');
  if (!wrappers.length) return;

  wrappers.forEach(wrapper => {
    const slides = wrapper.querySelector('.slides');
    const slideEls = gsap.utils.toArray(wrapper.querySelectorAll('.slide'));

    if (!slides || !slideEls.length) return;

    const proxy = document.createElement('div');
    const props = gsap.getProperty(proxy);

    let imgWidths = [];
    let slideHeight;
    let wrapWidth;
    let animation;
    let draggable;

    wrapper.classList.remove('no-js');
    wrapper.classList.add('js');

    /** Helpers **/
    function getSlidePosition(index) {
      return imgWidths
        .slice(0, index)
        .reduce((total, width) => total + width, 0);
    }

    function updateProgress() {
      animation.progress(gsap.utils.wrap(0, 1)(props('x') / wrapWidth));
    }

    function createDraggable() {
      if (draggable) draggable.kill();

      draggable = Draggable.create(proxy, {
        trigger: wrapper,
        type: 'x',
        inertia: true,
        onDrag: updateProgress,
        onThrowUpdate: updateProgress
      })[0];
    }

    function setupSlider() {
      imgWidths = [];
      slideHeight = slides.clientHeight;

      slideEls.forEach(el => {
        el.style.width = '';
        el.style.height = '';
        imgWidths.push(el.clientWidth);
      });

      wrapWidth = imgWidths.reduce((a, b) => a + b, 0);

      slideEls.forEach((el, i) => {
        gsap.set(el, {
          x: getSlidePosition(i),
          width: el.clientWidth,
          height: slideHeight
        });
      });

      gsap.set(slides, {
        left: -slideEls[0].clientWidth
      });

      gsap.set(proxy, { x: 0 });

      animation = gsap.to(slideEls, {
        duration: slideEls.length * 3,
        x: `+=${wrapWidth}`,
        ease: 'none',
        repeat: -1,
        modifiers: {
          x: x => `${parseFloat(x) % wrapWidth}px`
        }
      }).progress(1 / slideEls.length);

      createDraggable();
    }

    /** Events **/
    function pause() {
      animation.pause();
    }

    function play() {
      animation.play();
    }

    wrapper.addEventListener('mouseenter', pause);
    wrapper.addEventListener('mouseleave', play);

    let resizeTimeout;
    function resize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (!animation) return;
        const progress = animation.progress();
        animation.kill();
        setupSlider();
        animation.progress(progress);
      }, 150);
    }

    window.addEventListener('resize', resize);
    window.addEventListener('load', setupSlider);
  });
}
